import React from 'react'
import { useGesture } from 'react-use-gesture'
import defaultRender from './defaultRender'

export default function FlipBook({
  width = 600,
  length = 3,
  render = defaultRender
}) {
  const range = length * width

  const [dragState, setDragState] = React.useState({
    offset: 0,
    dragging: undefined,
    started: false,
  })

  const setProgress = progress =>
    setDragState(dragState => ({
      offset: progress * range,
      dragging: false,
      started: true,
    }))

  const progress = Math.min(1, dragState.offset / range)

  const bind = useGesture({
    onDrag: state => {
      state.event.stopPropagation()
      if (
        Math.abs(state.direction[0]) > 0.8 &&
        Math.abs(state.direction[1]) < 1
      ) {
        setDragState(dragState => ({
          offset: Math.min(
            range,
            Math.max(0, dragState.offset + state.delta[0])
          ),
          dragging: state.dragging ? state.direction[0] : undefined,
          started: true
        }))
      }
    }
  })

  return (
    <div
      {...bind()}
      style={{
        cursor: dragState.dragging
          ? dragState.dragging > 0
            ? 'e-resize'
            : 'w-resize'
          : 'ew-resize	',
        userSelect: 'none',
        overflow: 'hidden'
      }}
    >
      {render(width, progress, setProgress, dragState.started)}
    </div>
  )
}
